import Cookies from 'js-cookie'

export default class {
  constructor(element) {
    this.element = element
    this.name = this.element.getAttribute('data-name')
    this.accepted = this.element.querySelector('.-newsletter-accepted')
    this.declined = this.element.querySelectorAll('.-newsletter-declined')

    this.accepted.addEventListener('click', this.onAccept.bind(this))
    this.declined.forEach((e) =>
      e.addEventListener('click', this.onDecline.bind(this)),
    )

    // Displays newsletter window with a delay if cookies have already been accepted and the user wasn't already asked.
    if (!Cookies.get(this.getName()) && Cookies.get('cookie-agreed') === '2') {
      setTimeout(() => {
        this.element.classList.remove('-hidden')
      }, 15000)
    }

    window.addEventListener(
      'load',
      () => {
        const cookiesAcceptBtn = document.querySelector(
          '.eu-cookie-compliance-secondary-button',
        )

        if (cookiesAcceptBtn && this.element) {
          cookiesAcceptBtn.addEventListener('click', () => {
            setTimeout(() => {
              this.element.classList.remove('-hidden')
            }, 15000)
          })
        }
      },
      false,
    )
  }

  onAccept() {
    this.element.classList.add('-hidden')
    Cookies.set(this.getName(), true, { expires: 365 })
  }

  onDecline() {
    this.element.classList.add('-hidden')
    Cookies.set(this.getName(), false, { expires: 365 })
  }

  getName() {
    return `fenaco-${this.name}`
  }
}
